import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';

import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import useRedirectEstablishmentActiveContent from '../../../../Components/Hooks/useRedirectEstablishmentActiveContent';
import Search404 from '../../../AuthenticationInner/Errors/Search';
import StockList from './StockList';

const RespelStock = () => {
	const { establishmentId } = useParams();
	useRedirectEstablishmentActiveContent(
		'/residue/respel/stock/establishmentId',
	);

	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Medio Ambiente', icon: 'icon-leaf' },
		{ to: '/residue/dashboard', label: 'Residuos', icon: 'icon-recycle' },
		{ to: '#', label: 'RESPEL', icon: 'icon-circle-alert' },
	];

	if (establishmentId === 'all') {
		return (
			<>
				<UiContent />
				<div className='page-content mb-10' style={{ paddingBottom: '90px' }}>
					<Container fluid>
						<BreadCrumb title='Stock RESPEL' hidden icon='icon-warehouse' />
						<Search404 />
					</Container>
				</div>
			</>
		);
	}

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb
						title='Stock RESPEL'
						links={breadcrumbLinks}
						icon={'icon-warehouse'}
					/>
					<StockList establishmentId={establishmentId} />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default RespelStock;
